var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21350_8883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21350_8883",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H24V24H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21350_8883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3306 15.8303V18.4969C11.3306 19.0503 11.7773 19.4969 12.3306 19.4969C12.884 19.4969 13.3306 19.0503 13.3306 18.4969V15.8303C13.3306 15.2769 12.884 14.8303 12.3306 14.8303C11.7773 14.8303 11.3306 15.2769 11.3306 15.8303ZM15.3306 15.8303V18.4969C15.3306 19.0503 15.7773 19.4969 16.3306 19.4969C16.884 19.4969 17.3306 19.0503 17.3306 18.4969V15.8303C17.3306 15.2769 16.884 14.8303 16.3306 14.8303C15.7773 14.8303 15.3306 15.2769 15.3306 15.8303ZM10.9973 22.8303H21.664C22.2173 22.8303 22.664 22.3836 22.664 21.8303C22.664 21.2769 22.2173 20.8303 21.664 20.8303H10.9973C10.444 20.8303 9.99731 21.2769 9.99731 21.8303C9.99731 22.3836 10.444 22.8303 10.9973 22.8303ZM19.3306 15.8303V18.4969C19.3306 19.0503 19.7773 19.4969 20.3306 19.4969C20.884 19.4969 21.3306 19.0503 21.3306 18.4969V15.8303C21.3306 15.2769 20.884 14.8303 20.3306 14.8303C19.7773 14.8303 19.3306 15.2769 19.3306 15.8303ZM15.7106 9.15695L10.444 11.9303C10.1706 12.0703 9.99731 12.357 9.99731 12.6636C9.99731 13.1236 10.3706 13.497 10.8306 13.497H21.8373C22.2906 13.497 22.664 13.1236 22.664 12.6636C22.664 12.357 22.4906 12.0703 22.2173 11.9303L16.9506 9.15695C16.564 8.95029 16.0973 8.95029 15.7106 9.15695Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21350_8883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecking);
export default __webpack_public_path__ + "static/media/checking.857a2cc8017d6a213ad3720f29bf8488.svg";
export { ForwardRef as ReactComponent };